import {Component, OnInit} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {CacheService} from './services/cache.service';
import {PushNotificationService} from './services/push-notification.service';
import {ThemeService} from './services/theme.service';
import {filter} from 'rxjs/operators';
import {fromEvent, interval} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private cacheService: CacheService,
    private pushNotificationService: PushNotificationService,
    private themeService: ThemeService,
    private swUpdate: SwUpdate,
  ) {
    this.cacheService.initStorage();
    this.themeService.apply();
    this.pushNotificationService.registerNotifications();
  }

  ngOnInit() {
    this.watchForUpdates();
  }

  private watchForUpdates() {
    if (!this.swUpdate.isEnabled) { return; }

    // When a new version is ready — activate and reload immediately
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
    ).subscribe(() => {
      this.swUpdate.activateUpdate().then(() => window.location.reload());
    });

    // 1) Check right away when the app starts
    this.swUpdate.checkForUpdate();

    // 2) Check every time the user switches back to this tab
    fromEvent(window, 'focus').subscribe(() => this.swUpdate.checkForUpdate());

    // 3) Check every 5 minutes as a background fallback
    interval(5 * 60 * 1000).subscribe(() => this.swUpdate.checkForUpdate());
  }
}
